(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["page-video-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ck-video-frame')) {
    customElements.define(
      'ck-video-frame',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.closest('dialog');
          if (!this.dialog) return;
          this.onOpen = () => this.load();
          this.onClose = () => this.replaceChildren();
          this.dialog.addEventListener('ck:open', this.onOpen);
          this.dialog.addEventListener('close', this.onClose);
        }

        disconnectedCallback() {
          if (!this.dialog) return;
          this.dialog.removeEventListener('ck:open', this.onOpen);
          this.dialog.removeEventListener('close', this.onClose);
        }

        load() {
          if (!this.dataset.src || this.querySelector('iframe')) return;
          const iframe = document.createElement('iframe');
          iframe.src = this.dataset.src;
          iframe.title = this.dataset.title || '';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          this.append(iframe);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
